import type { TerminalServerMessage } from '@this+that/models';

import { createListeners } from './createListeners';
import { TerminalSendError, type TerminalTransport } from './types';
import {
  TerminalConnectionStatus,
  TerminalSendFailure,
  TerminalTransportKind,
} from '../../../enums/terminal';

export function createNoneTransport(): TerminalTransport {
  const messages = createListeners<TerminalServerMessage>();
  const statuses = createListeners<TerminalConnectionStatus>();
  return {
    connect: () => statuses.emit(TerminalConnectionStatus.NO_DAEMON),
    send: async () => {
      throw new TerminalSendError(TerminalSendFailure.NOT_FOUND);
    },
    onMessage: messages.subscribe,
    onStatus: statuses.subscribe,
    getKind: () => TerminalTransportKind.NONE,
    close: () => {
      messages.clear();
      statuses.clear();
    },
  };
}
